class Subscription {
	id = 0;
	date = null;
	magazine_id = null;
	title = null;
	private_count = 0;
	branch_count = 0;
	bookstore_count = 0;
	total_count = 0;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Subscription;
